import { ATP_API_URL } from "../config/apiConfig";
import { apiClient } from "../services/apiClient";

/**
 * Fetches a document as a blob and opens it in a new tab.
 * GET api/Onboarding/view-document?entityPrimaryId={id}&filePath={path}
 *
 * @param {number} entityPrimaryId
 * @param {string} filePath  - raw Windows path from the API response
 */
export const viewDocumentAction = async (entityPrimaryId, filePath) => {
  try {
    const response = await apiClient.get(ATP_API_URL.VIEW_DOCUMENT, {
      params: { entityPrimaryId, filePath },
      responseType: "blob",
    });
    console.log("Response : ", response);

    if (response?.status === 200 && response.data) {
      const blob = new Blob([response.data], {
        type: response.headers?.["content-type"] || "application/octet-stream",
      });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener,noreferrer");
      // Revoke after a short delay so the tab has time to load
      setTimeout(() => URL.revokeObjectURL(url), 10000);
      return { success: true };
    }

    return { success: false, error: "Failed to load document" };
  } catch (error) {
    console.error("[ViewDocument] error:", error);
    return { success: false, error: error.message };
  }
};
